import { createApp } from 'vue'
import {createBootstrap} from 'bootstrap-vue-next'
import App from './App.vue'
import router from './router'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment';
import cookie from './plugins/cookie'

import Vue3ConfirmDialog from 'vue3-confirm-dialog';
import 'vue3-confirm-dialog/style';
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

let app=createApp(App);
app.config.globalProperties.$moment=moment;

app.use(createBootstrap())
app.use(ToastPlugin,{
    position: 'top-right'
})
app.use(Vue3ConfirmDialog)
app.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)
app.use(router)
app.use(cookie)
app.component('VueDatePicker', VueDatePicker)
app.use(LoadingPlugin,{
    loader: 'dots',
    enforceFocus: false
})
app.component('v-select', vSelect)

app.mount('#app')
